import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {ScoresListHeaderModuleConfig} from "./scores-list-header-module.config";
import {ScoresListHeaderModuleStore} from "./scores-list-header-module.store";
import {ScoresListHeaderModuleHandlers} from "./handlers/scores-list-header-module.handlers";

export class ScoresListHeaderModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, ScoresListHeaderModuleConfig, ScoresListHeaderModuleStore, ScoresListHeaderModuleHandlers];

  get isWidget() {
    return this.appSettings.isWidget;
  }
}
